/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlayerPerformanceStatistic } from './PlayerPerformanceStatistic';
import {
    PlayerPerformanceStatisticFromJSON,
    PlayerPerformanceStatisticFromJSONTyped,
    PlayerPerformanceStatisticToJSON,
    PlayerPerformanceStatisticToJSONTyped,
} from './PlayerPerformanceStatistic';
import type { CategoryStatistics } from './CategoryStatistics';
import {
    CategoryStatisticsFromJSON,
    CategoryStatisticsFromJSONTyped,
    CategoryStatisticsToJSON,
    CategoryStatisticsToJSONTyped,
} from './CategoryStatistics';
import type { TeamPerformanceStatistic } from './TeamPerformanceStatistic';
import {
    TeamPerformanceStatisticFromJSON,
    TeamPerformanceStatisticFromJSONTyped,
    TeamPerformanceStatisticToJSON,
    TeamPerformanceStatisticToJSONTyped,
} from './TeamPerformanceStatistic';
import type { TeamStatistic } from './TeamStatistic';
import {
    TeamStatisticFromJSON,
    TeamStatisticFromJSONTyped,
    TeamStatisticToJSON,
    TeamStatisticToJSONTyped,
} from './TeamStatistic';
import type { PlayerScoreStatistic } from './PlayerScoreStatistic';
import {
    PlayerScoreStatisticFromJSON,
    PlayerScoreStatisticFromJSONTyped,
    PlayerScoreStatisticToJSON,
    PlayerScoreStatisticToJSONTyped,
} from './PlayerScoreStatistic';
import type { MatchStatistics } from './MatchStatistics';
import {
    MatchStatisticsFromJSON,
    MatchStatisticsFromJSONTyped,
    MatchStatisticsToJSON,
    MatchStatisticsToJSONTyped,
} from './MatchStatistics';

/**
 * 
 * @export
 * @interface TournamentStatistics
 */
export interface TournamentStatistics {
    /**
     * 
     * @type {Array<PlayerPerformanceStatistic>}
     * @memberof TournamentStatistics
     */
    playerStatistics?: Array<PlayerPerformanceStatistic>;
    /**
     * 
     * @type {Array<PlayerPerformanceStatistic>}
     * @memberof TournamentStatistics
     */
    goalkeeperStatistics?: Array<PlayerPerformanceStatistic>;
    /**
     * 
     * @type {Array<TeamPerformanceStatistic>}
     * @memberof TournamentStatistics
     */
    teamPerformance?: Array<TeamPerformanceStatistic>;
    /**
     * 
     * @type {Array<PlayerScoreStatistic>}
     * @memberof TournamentStatistics
     */
    topScorers?: Array<PlayerScoreStatistic>;
    /**
     * 
     * @type {Array<TeamStatistic>}
     * @memberof TournamentStatistics
     */
    topTeams?: Array<TeamStatistic>;
    /**
     * 
     * @type {MatchStatistics}
     * @memberof TournamentStatistics
     */
    matchStatistics?: MatchStatistics;
    /**
     * 
     * @type {Array<CategoryStatistics>}
     * @memberof TournamentStatistics
     */
    categoryStatistics?: Array<CategoryStatistics>;
}

/**
 * Check if a given object implements the TournamentStatistics interface.
 */
export function instanceOfTournamentStatistics(value: object): value is TournamentStatistics {
    return true;
}

export function TournamentStatisticsFromJSON(json: any): TournamentStatistics {
    return TournamentStatisticsFromJSONTyped(json, false);
}

export function TournamentStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'playerStatistics': json['playerStatistics'] == null ? undefined : ((json['playerStatistics'] as Array<any>).map(PlayerPerformanceStatisticFromJSON)),
        'goalkeeperStatistics': json['goalkeeperStatistics'] == null ? undefined : ((json['goalkeeperStatistics'] as Array<any>).map(PlayerPerformanceStatisticFromJSON)),
        'teamPerformance': json['teamPerformance'] == null ? undefined : ((json['teamPerformance'] as Array<any>).map(TeamPerformanceStatisticFromJSON)),
        'topScorers': json['topScorers'] == null ? undefined : ((json['topScorers'] as Array<any>).map(PlayerScoreStatisticFromJSON)),
        'topTeams': json['topTeams'] == null ? undefined : ((json['topTeams'] as Array<any>).map(TeamStatisticFromJSON)),
        'matchStatistics': json['matchStatistics'] == null ? undefined : MatchStatisticsFromJSON(json['matchStatistics']),
        'categoryStatistics': json['categoryStatistics'] == null ? undefined : ((json['categoryStatistics'] as Array<any>).map(CategoryStatisticsFromJSON)),
    };
}

export function TournamentStatisticsToJSON(json: any): TournamentStatistics {
    return TournamentStatisticsToJSONTyped(json, false);
}

export function TournamentStatisticsToJSONTyped(value?: TournamentStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'playerStatistics': value['playerStatistics'] == null ? undefined : ((value['playerStatistics'] as Array<any>).map(PlayerPerformanceStatisticToJSON)),
        'goalkeeperStatistics': value['goalkeeperStatistics'] == null ? undefined : ((value['goalkeeperStatistics'] as Array<any>).map(PlayerPerformanceStatisticToJSON)),
        'teamPerformance': value['teamPerformance'] == null ? undefined : ((value['teamPerformance'] as Array<any>).map(TeamPerformanceStatisticToJSON)),
        'topScorers': value['topScorers'] == null ? undefined : ((value['topScorers'] as Array<any>).map(PlayerScoreStatisticToJSON)),
        'topTeams': value['topTeams'] == null ? undefined : ((value['topTeams'] as Array<any>).map(TeamStatisticToJSON)),
        'matchStatistics': MatchStatisticsToJSON(value['matchStatistics']),
        'categoryStatistics': value['categoryStatistics'] == null ? undefined : ((value['categoryStatistics'] as Array<any>).map(CategoryStatisticsToJSON)),
    };
}

